import React, { useMemo } from 'react';
import _keyBy from 'lodash/keyBy';
import isFieldValidConfigOption from 'helpers/isFieldValidConfigOption';
import * as FormValues from 'types/FormValue';
import { Field } from '@sift/types';
import * as Types from 'pages/Features/typings';
import parentFieldIsObjectArray from 'helpers/parentFieldIsObjectArray';

// Components
import LayoutSettingCard from 'molecules/LayoutSettingCard';

interface Props {
  onChange: (field: any, value: FormValues.FormValue) => void;
  userStatus: number;
  fields: Field[];
  values: Types.FeatureValues;
}

export const HIGHLIGHT_SUBTITLE_COPY =
  'Configure which attributes may be highlighted by in your org chart. If no attributes are defined, the feature will be hidden.';

export const HIGHLIGHTABLE_FIELD_TYPES = ['text', 'textSelect', 'boolean', 'number'];

export const highlightByFilter = (field: Field, fields: Field[]) => {
  const fieldTypeIsHighlightable = (field: Field) => HIGHLIGHTABLE_FIELD_TYPES.includes(field.type);

  return (
    fieldTypeIsHighlightable(field) &&
    isFieldValidConfigOption(field) &&
    !parentFieldIsObjectArray(field, fields)
  );
};

function OrgChartHighlightsLayout({ userStatus, fields, onChange, values }: Props) {
  const keyedFields = useMemo(() => _keyBy(fields, 'objectKey'), [fields]);

  return (
    <LayoutSettingCard
      cardTitle="Highlighting"
      dialogTitle="Configure Highlighting"
      filter={field => highlightByFilter(field, fields)}
      layoutKey="org-chart-highlight-by"
      subtitle={HIGHLIGHT_SUBTITLE_COPY}
      userStatus={userStatus}
      fields={keyedFields}
      onChange={onChange}
      values={values}
      typeKey="user"
    />
  );
}

export default OrgChartHighlightsLayout;
